import {
  getTransportCompanyAndRouteParams,
  getTransportIdParams,
} from '@/app/components/hotel-detail/common/tracking.ts';

export const CHOOSE_FLIGHT_SHOWN = 'CHOOSE_FLIGHT_SHOWN';
export const CHOOSE_FLIGHT_SHOWN_VERSION = '1.2';

export type ChooseFlightShownPayload = {
  inboundAirlineId: string;
  inboundRouteId: string;
  outboundAirlineId: string;
  outboundRouteId: string;
  productDetailKey: string;
  searchId: string;
  flightClickId: string;
};

export type ChooseFlightShownParams = {
  searchId: string;
  productDetailKey: string;
  flightClickId: string;
  transport: TransportsType | undefined;
};

export const createChooseFlightShownPayload = ({
  searchId,
  productDetailKey,
  flightClickId,
  transport,
}: ChooseFlightShownParams): ChooseFlightShownPayload => ({
  searchId,
  productDetailKey,
  flightClickId,
  ...getTransportIdParams(transport),
  ...getTransportCompanyAndRouteParams(transport),
});
